import * as React from "react"
import Link from "./link"; 

const ArrowLink = ({to, text, sup, className}) => (
  <Link to={to} className={"read--more link flex align-center "+className}><span />
    <p className="mt0 mb0  m-underline">{text}<sup className="circular">{sup}</sup></p>
  </Link>
) 
export default ArrowLink
